import { render, staticRenderFns } from "./ArticleCategory.vue?vue&type=template&id=6dcabcd2&"
import script from "./ArticleCategory.vue?vue&type=script&lang=js&"
export * from "./ArticleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports